

























































































import Vue from 'vue'
import _ from 'lodash'
import {
  LOAD_DETAIL,
  LOAD_EDUCATION,
  LOAD_JOBS,
  LOAD_SPECIALIZATION,
  LOAD_COMPETENCE, FETCH_MASTER_DATA_WORK_LIST
} from '@/store/action-types'
import { LevelOfEducation } from '@/model/qcq/LevelOfEducation'
import QcqViewGrid from '@/components/QcqViewGrid.vue'
import { Jobs } from '@/model/qcq/Jobs'
import { Specialization } from '@/model/qcq/Specialization'
import { Detail } from '@/model/qcq/Detail'
import { QcqShiftCompetences } from '@/model/master-data/QcqShiftCompetences'
import { Competence } from '@/model/qcq/Competence'
import { QcqCommonGridItem, UiLanguageItem } from '@/types'
import QcqQualityStarsSelector from '@/components/master-data/shifts/QcqQualityStarsSelector.vue'
import { GetArbeitenResponse } from '@/types/service-response'
import { Work } from '@/model/master-data/Work'

interface ComponentData {
  workList: Work[]
  selectedLevelOfEducation: number | undefined
  formData: QcqShiftCompetences | undefined
  levelOfEducationData: Array<LevelOfEducation>
  jobsData: Array<Jobs>
  specializationsData: Array<Specialization>
  detailData: Array<Detail>
  competencesList: Array<QcqCommonGridItem>
}

export default Vue.extend({
  name: 'QcqShiftOffsetEditorDialog',

  components: {
    QcqViewGrid,
    QcqQualityStarsSelector
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    dialogData: {
      type: Object as () => QcqShiftCompetences
    },
    maxStars: Number
  },

  data (): ComponentData {
    return {
      workList: [],
      selectedLevelOfEducation: undefined,
      formData: undefined,
      levelOfEducationData: [],
      jobsData: [],
      specializationsData: [],
      detailData: [],
      competencesList: [],
    }
  },

  computed: {
    selectedUiLanguage (): UiLanguageItem {
      return this.$store.state.selectedUiLanguage
    },
  },

  watch: {
    dialogData (newVal: boolean): void {
      const form: any = this.$refs['form']
      if(form) {
        form.resetValidation()
      }

      if (newVal) {
        this.selectedLevelOfEducation = undefined
        this.jobsData = []
        this.specializationsData = []
        this.detailData = []
        this.formData = _.cloneDeep(this.dialogData)
      }
    },

    selectedLevelOfEducation (newVal: number | undefined): void {
      if (newVal) {
        if (this.formData && this.levelOfEducationData) {
          let foundLevelOfEducation: any = this.levelOfEducationData.find((item: any) => item.id === newVal)
          this.formData.educationLevelId = foundLevelOfEducation.id
          this.formData.educationLevelDescription = foundLevelOfEducation.description
          this.formData.jobId = null
          this.formData.jobDescription = ''
          this.formData.specializationId = null
          this.formData.specializationDescription = ''
          this.formData.detailsId = null,
          this.formData.detailsDescription = ''
        }

        this.$store.dispatch(LOAD_JOBS, newVal)
          .then((data: Array<Jobs>) => {
            this.jobsData = data
            this.specializationsData = []
            this.detailData = []
          })
      }
    }
  },

  methods: {
    getWorkLabel (item: Work): string {
      return `${item.code} - ${item.getDescriptionLabel}`
    },

    onChangeQuality (item: number | null): void {
      if(this.formData) {
        this.formData.quality = item
      }
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate() && this.formData) {
        this.competencesList.forEach((item: QcqCommonGridItem) => {
          if (this.formData && item.id === this.formData.competences) {
            this.formData.competencesDescription = item.description
          }
        })

        const workItem: Work | undefined = _.find(this.workList, { id: this.formData.work })
        if (workItem) {
          this.formData.workCode = workItem.getDescriptionLabel
          this.formData.workItem = workItem
        }

        this.$emit('createNewOffset', this.formData)
      }
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onJobsClicked (row: QcqCommonGridItem): void { // BerufeID
      if (this.formData) {
        this.formData.jobId = row.id
        this.formData.jobDescription = row.description
      }
      this.$store.dispatch(LOAD_SPECIALIZATION, row.id)
        .then((data: Array<Specialization>) => {
          this.specializationsData = data
          this.detailData = []
        })
    },

    onSpecializationClicked (row: QcqCommonGridItem): void { // FachrichtungenID
      if (this.formData) {
        this.formData.specializationId = row.id
        this.formData.specializationDescription = row.description
      }
      this.$store.dispatch(LOAD_DETAIL, row.id)
        .then((data: Array<Detail>) => {
          this.detailData = data
        })

    },

    onDetailClicked (row: QcqCommonGridItem): void {
      if (this.formData) {
        this.formData.detailsId = row.id
        this.formData.detailsDescription = row.description
      }
    },

    async fetchWorkList (): Promise<void> {
      try {
        const response: GetArbeitenResponse = await this.$store.dispatch(FETCH_MASTER_DATA_WORK_LIST)
        if(response && !response.IsError) {
          this.workList =  Work.createListFromResponse(response.Arbeiten)
        } else {}
      } catch (e) {}
    }
  },

  created () {
    this.formData = new QcqShiftCompetences(
      undefined,
      undefined,
      undefined,
      null,
      '',
      null,
      '',
      null,
      '',
      null,
      '',
      null,
      '',
      '',
      undefined,
      undefined,
      0,
      '',
      '00:00',
      undefined,
      null
    )

  },

  async mounted (): Promise<void> {
    this.$store.dispatch(LOAD_EDUCATION)
      .then((data: Array<LevelOfEducation>) => {
        const gridData = data.map((item: LevelOfEducation) => {
          return item.commonGridData as any
        })
        this.levelOfEducationData = gridData
      })

    this.$store.dispatch(LOAD_COMPETENCE, 1)
      .then((data: Array<Competence>) => {
        data.forEach((item: Competence) => {
          this.competencesList.push(item.commonGridData)
        })
      })

    this.fetchWorkList()

  }
})
